export const Empty_String = "";

export const Products = {
    IUL: 'Index Universal Life',
    GUL: 'Guaranteed Universal Life',
    UL: 'Universal Life',
    VUL: 'Variable Universal Life',
    Short_Term_DI: 'Short-Term Disability',
    Long_Term_DI: 'Long-Term Disability',
    SIWL: 'Simplified Issue Whole Life',
    SPWL: 'Single Premium Whole Life',
    TWL: 'Traditional Whole Life',
    TERM: 'Term Life Insurance',
    Guaranteed_FE: 'Guaranteed Life',
    Gerber_FE: 'Gerber',
    ASSURITY: 'Assurity',
    AMERITAS: 'Ameritas',
    MASSMUTUAL: 'MassMutual',
    PRINCIPAL: 'Principal'
}

export const ProductKeys = {
    WS_SPWL: 'ws-spwl',
    PROTECTIVE_SPWL: 'protective-spwl',
    TERM_INSURANCE: 'term-insurance',
    SINGLE_PREMIUM_WHOLE_LIFE: 'single-premium-whole-life',
    ASSET_BASED_HYBRID_LTC: 'asset-based-hybrid-ltc',
    TRADITIONAL_LTC: 'traditional-ltc',
    GUARANTEED_UNIVERSAL_LIFE: 'guaranteed-universal-life',
    PERM_INSURANCE: 'perm-insurance',
    TRADITIONAL_UNIVERSAL_LIFE: 'traditional-universal-life',
    WHOLE_LIFE_INSURANCE: 'whole-life-insurance',
    VARIABLE_UNIVERSAL_LIFE_CURRENT_ASSUMPTION: 'variable-universal-life-current-assumption',
    DISABILITY_INSURANCE: 'disability-insurance',
    FINAL_EXPENSE: 'final-expense',
}

export const clientTypes = {
    EXISTING: 'Existing Client',
    PROSPECT: 'Prospect',
}

export const clientTypeOptions = [
    { value: clientTypes.EXISTING, label: clientTypes.EXISTING },
    { value: clientTypes.PROSPECT, label: clientTypes.PROSPECT },
]

export const GenderOptions = [
    { value: 'F', label: 'Female' },
    { value: 'M', label: 'Male' },
];

export const MaritalStatusOptions = [
    { value: "S", label: "Single" },
    { value: "M", label: "Married" },
]

export const TobaccoOptions = [
    { label: "Currently or previously used", value: "true" },
    { label: "No usage in the last year", value: "false" },
]

export const ONE_CLICK_PRODUCT_TYPE_ID = {
    term: 52,
    illustrationRequest: 70,
    permRequest: 49,
    permIULRequest: 53,
    universalLife: 68,
    appSubmit: 39,
    hybridLTC: 42,
    gul: 62,
    minnSLWL: 25,
}

export const JourneyTypes = {
    TERM: "term",
    GUL: "gul",
    REQUEST_ILLUSTRATIONS: "illustrationRequest",
    IUL_ESTIMATOR: "permIULRequest",
    UL_ESTIMATOR: "universalLife",
    APP_SUBMIT: "appSubmit",
    ABLTC_ESTIMATOR: "hybridLTC",
    SPL: "minnSLWL",
}



// WEBPACK FOOTER //
// ./src/types/sharedConstants.js